import React, { useEffect, useRef, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Popup from 'reactjs-popup';
import { MdContentCopy } from "react-icons/md";
import { Button, Modal } from 'react-bootstrap';
import { getUserByAddress, UserUpdate } from '../../hooks/User';
import { ToastContainer, toast } from 'react-toastify';
import { FaCamera, FaEdit, FaTrash } from "react-icons/fa";
import useFullPageLoader from '../../hooks/useFullPageLoader';
import LightBg from "../../assets/img/bg/Dark Background.png"
import DefaultProfile from "../../assets/img/avatars/defaultProfile.png"
import { client } from '../../config/ipfsConfig';
import { IoIosMore } from "react-icons/io";
const HeroProfile = (props) => {
  const ref = useRef();
  // const user = props.user;
  const [isActive, setActive] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [isMore, setMore] = useState(false);
  const [isShare, setShare] = useState(false);
  const [open, setOpen] = useState(false);

  const [user, setUser] = useState({});
  const walletAddress = props.address;
  // const [loader, showLoader, hideLoader] = useFullPageLoader();
  // const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [showProfileOptions, setShowProfileOptions] = useState(false);
  const [showCoverOptions, setShowCoverOptions] = useState(false);
  const optionsRef = useRef(null);
  const profileOptionsRef = useRef(null);
  const Navigate = useNavigate();

  const location = useLocation();
  const locationOfProfile = location.pathname.split('/')[1];
  console.log("location", locationOfProfile, user);

  function closeModal() {
    setOpen(false);
  }

  const onCopyText = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  const Upgrade = () => {
    // showLoader();
    const body = {
      isProfileNFT: true
    }
    UserUpdate(body, user._id).then((data) => {
      console.log("data", data);
    })
    setOpen(!open)
    setTimeout(() => {
      // hideLoader()
    }, 2000);
    toast.success("Profile Photo upgrade as a NFT !!!")
    // setTimeout(() => {
    //   Navigate('/profile');
    // }, 2000);
  }

  useEffect(() => {
    Getuser();
  }, [walletAddress]);

  const Getuser = () => {
    getUserByAddress(walletAddress).then((data) => {
      if (data.status === 200) {
        setUser(data.user)
      }
    })
  }

  // Add Cover Photo
  const AddCoverPhoto = async (e) => {
    const file = e.target.files[0]; // Get the selected file
    if (!file) {
      toast.error('No file selected!');
      return;
    }

    try {
      // Upload file to IPFS
      const added = await client.add(file);
      const url = `https://ipfs.infura.io/ipfs/${added.path}`;

      if (user) {
        const body = {
          coverPicture: url, // Updating the cover picture URL
        };

        // Update user data
        const data = await UserUpdate(body, user._id);
        if (data.status === 200) {
          Getuser(); // Refresh user data
          toast.success('Cover Picture updated successfully!');
        } else {
          toast.error('Failed to update Cover Picture!');
        }
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      toast.error('Error uploading file.');
    }
  };

  // Delete Cover Photo
  const DeleteCoverPhoto = async () => {
    try {
      // Replace the cover photo with this new image URL
      const newCoverPicURL = "https://ipfs.infura.io/ipfs/QmTUzVkSaR4LRZeVq6DHpeQcna62zAbfsfUci4fihUtbq2";
      const updateBody = { coverPicture: newCoverPicURL };

      console.log("updateBody", updateBody);

      const updateResponse = await UserUpdate(updateBody, user._id);
      if (updateResponse.status === 200) {
        toast.success("Cover photo replaced successfully!");
        Getuser(); // Refresh user data to reflect the change
      } else {
        toast.error("Failed to update cover photo.");
      }
    } catch (error) {
      toast.error("Error updating cover photo.");
      console.error("Error:", error);
    }
  };

  // Close options if clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setShowCoverOptions(false); // Close the options when clicking outside
      }
    };

    // Bind the event listener
    document.addEventListener('click', handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const AddProfilePhoto = async (e) => {
    const file = e.target.files[0]; // Get the selected file
    if (!file) {
      toast.error('No file selected!');
      return;
    }

    try {
      // Upload file to IPFS
      const added = await client.add(file);
      const url = `https://ipfs.infura.io/ipfs/${added.path}`;

      if (user) {
        const body = {
          profilePicture: url, // Updating the profile picture URL
        };

        // Update user data
        const data = await UserUpdate(body, user._id);
        if (data.status === 200) {
          Getuser(); // Refresh user data
          toast.success('Profile Picture updated successfully!');
        } else {
          toast.error('Failed to update Profile Picture!');
        }
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      toast.error('Error uploading file.');
    }
  };

  // Delete Profile Photo
  const DeleteProfilePhoto = async () => {
    try {

      const newProfilePicURL = "https://ipfs.infura.io/ipfs/QmQWX3qehN6pgmDx7n8dWf3EfdUP1iD1XGpmfMn338cAHq"; // Your new image URL
      const updateBody = { profilePicture: newProfilePicURL };

      console.log("updateBody", updateBody);

      const updateResponse = await UserUpdate(updateBody, user._id);
      if (updateResponse.status === 200) {
        toast.success("Profile picture replaced successfully!");
        // getUser(); // Refresh user data to reflect the change
        // setHasProfilePicture(true); // Update the state
      } else {
        toast.error("Failed to update profile picture.");
      }

    } catch (error) {
      toast.error('Error updating profile picture.');
      console.error('Error:', error);
    }
  };

  // Close options if clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileOptionsRef.current &&
        !profileOptionsRef.current.contains(event.target)
      ) {
        setShowProfileOptions(false); // Close the options when clicking outside
      }
    };

    // Bind the event listener
    document.addEventListener('click', handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);


  console.log("Profile", user);

  return (
    <div className="mb-100">
      <div className="hero__profile">
        <div className="cover" style={{ position: 'relative' }}>
          <img
            src={user.coverPicture ? user.coverPicture : LightBg} // Default background image
            alt="Cover"
          // style={{ width: '100%', height: 'auto' }}
          />
          <div
            style={{
              position: 'absolute',
              bottom: '12px',
              right: '15px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              color: '#fff',
              width: '35px',
              height: '35px',
              borderRadius: '50%',
              cursor: 'pointer',
              animation: 'bounce 1.5s infinite',
            }}
            onClick={() => setShowCoverOptions(!showCoverOptions)} // Toggle show/hide options
          >
            <div id="boxCoverUpload">
              <FaCamera
                size={20}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '-3px',
                }}
              />
              <input
                id="imageCoverUpload"
                type="file"
                name="cover_photo"
                placeholder="Photo"
                required
                onChange={AddCoverPhoto}
                capture
                style={{ display: 'none' }} // Hide the file input
              />
            </div>
          </div>

          {/* Options Menu */}
          {showCoverOptions && (
            <div
              style={{
                position: 'absolute',
                bottom: '15px', // Adjust to show above the camera icon
                right: '70px',
                borderRadius: '5px',
                display: 'flex',
                alignItems: 'flex-start',
                zIndex: 100,
              }}
            >
              <div
                style={{
                  backgroundColor: '#007bff',
                  color: 'white',
                  margin: '0 10px',
                  height: '40px',
                  width: '40px',
                  padding: '10px',
                  borderRadius: '50%',
                  cursor: 'pointer',
                }}
              >
                {/* Edit Option */}
                <FaEdit
                  size={20}
                  onClick={() => document.getElementById('imageCoverUpload').click()} // Trigger file input for editing
                  style={{
                    color: 'white',
                    marginBottom: "100px",
                    cursor: 'pointer',
                  }}
                />
              </div>


              {/* Delete Option */}
              <div
                style={{
                  backgroundColor: '#dc3545',
                  color: 'white',
                  height: '40px',
                  width: '40px',
                  padding: '10px',
                  borderRadius: '50%',
                  cursor: 'pointer',
                }}
              >
                <FaTrash
                  size={20}
                  onClick={DeleteCoverPhoto} // Trigger cover photo delete
                  style={{
                    color: 'white',
                    marginBottom: "100px",
                    cursor: 'pointer',
                  }}
                />
              </div>

            </div>
          )}
        </div>

        <div className="infos">
          <div className="container">
            <div className="row flex-wrap align-items-center justify-content-between sm:space-y-50" >
              <div className="col-md-auto mr-20" >
                <div className="avatars d-flex space-x-20 align-items-center">
                  {/* Profile Photo Section */}
                  <div className="avatar_wrap" style={{ position: 'relative' }}>
                    <img
                      className="avatar avatar-lg"
                      src={user.profilePicture ? user.profilePicture : DefaultProfile}
                      alt="avatar"
                    />

                    {/* Camera Icon for Editing Profile Photo */}
                    <div
                      style={{
                        position: 'absolute',
                        bottom: '-55px', // Positioned slightly below the image
                        left: '70%',
                        transform: 'translateX(-50%)', // Centered horizontally
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        color: '#fff',
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                      }}
                      onClick={() => setShowProfileOptions(!showProfileOptions)} // Toggle the visibility of options
                    >
                      <div id="boxProfileUpload">
                        <FaCamera size={10} />
                        <input
                          id="imageProfileUpload"
                          type="file"
                          name="profile_photo"
                          placeholder="Photo"
                          required
                          onChange={AddProfilePhoto}
                          capture
                          style={{ display: 'none' }} // Hide the file input
                        />
                      </div>
                    </div>

                    {/* Show the Edit/Delete options if visible */}
                    {showProfileOptions && (
                      <div
                        style={{
                          position: 'absolute',
                          bottom: '-70px', // Positioned above the camera icon
                          left: '150px',
                          transform: 'translateX(-50%)',
                          padding: '10px',
                          borderRadius: '5px',
                          display: "flex",
                          alignItems: 'flex-start',
                          zIndex: 100,
                        }}
                      >
                        {/* Edit Option */}
                        <div
                          style={{
                            backgroundColor: '#007bff',
                            color: 'white',
                            margin: '0 10px',
                            height: '40px',
                            width: '40px',
                            padding: '10px',
                            borderRadius: '50%',
                            cursor: 'pointer',
                          }}
                        >

                          <FaEdit
                            size={20}
                            onClick={() => document.getElementById('imageProfileUpload').click()} // Trigger file input
                            style={{
                              color: 'white',
                              marginBottom: "100px",
                              cursor: 'pointer',
                            }}
                          />
                        </div>


                        {/* Delete Option */}
                        <div
                          style={{
                            backgroundColor: '#dc3545',
                            color: 'white',
                            height: '40px',
                            width: '40px',
                            padding: '10px',
                            borderRadius: '50%',
                            cursor: 'pointer',
                          }}
                        >
                          <FaTrash
                            size={20}
                            onClick={DeleteProfilePhoto} // Delete the profile photo
                            style={{
                              color: 'white',
                              marginBottom: "100px",
                              cursor: 'pointer',
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  {/* User Information */}
                  <div>
                    <h5>{user.name ? user.name : 'Name'}</h5>
                    <h6>{user.username ? user.username : '@username'}</h6>
                  </div>

                  {/* Optional Button to upgrade profile photo to NFT */}
                  {locationOfProfile === 'profile' && user.isProfileNFT === false && (
                    <Button onClick={() => console.log('Upgrade Profile Photo as NFT')}>
                      Upgrade Profile Photo as NFT
                    </Button>
                  )}
                </div>
              </div>


              <div className="col-md-auto">
                <div className="d-sm-flex flex-wrap align-items-center space-x-20 mb-20_reset d-sm-block">
                  <div className="mb-20">
                    <div className="copy">
                      <span className="color_text">
                        {user.walletAddress
                          ? `${user.walletAddress.slice(0, 10)}...${user.walletAddress.slice(-10)}`
                          : "Connect wallet"
                        }
                        <CopyToClipboard
                          text={user.walletAddress}
                          onCopy={onCopyText}
                          style={{ cursor: 'pointer' }}
                        >
                          <span className="mx-2">
                            {isCopied ? "Copied!" : <MdContentCopy className='icons__size1' />}
                          </span>
                        </CopyToClipboard>
                      </span>
                    </div>
                  </div>
                  <div className="d-flex flex-wrap align-items-center space-x-20">
                    <div className="mb-20">
                      <Link to="/kycs" className="btn btn-dark btn-sm p3">
                        KYC
                      </Link>
                    </div>

                  </div>
                  <div className="d-flex flex-wrap align-items-center space-x-20">
                    <div className="mb-20">
                      <div className="mb-20">
                        <div className="more">
                          <div
                            className="icon"
                            onMouseEnter={() => setMore(true)}
                            onMouseLeave={() => setMore(false)}
                          >
                            <IoIosMore style={{ color: "#183b56" }} />
                          </div>
                          <div
                            className={`dropdown__popup ${isMore ? 'visible' : ''}`}
                            onMouseEnter={() => setMore(true)}
                            onMouseLeave={() => setMore(false)}
                          >
                            <ul className="space-y-10">
                              <li>
                                <Popup
                                  className="custom"
                                  trigger={
                                    <Link to="#" className="content space-x-10 d-flex border-bottom">
                                      <span>Report</span>
                                    </Link>
                                  }
                                  position="bottom center"
                                >
                                  <div
                                    className="popup"
                                    id="popup_bid"
                                    tabIndex={-1}
                                    role="dialog"
                                    aria-hidden="true"
                                  >
                                    <div className="space-y-20">
                                      <h3>Thank you, we've received your report</h3>
                                    </div>
                                  </div>
                                </Popup>
                              </li>
                              {locationOfProfile === "profile" && (
                                <li>
                                  <Link
                                    to="/edit-profile"
                                    className="content space-x-10 d-flex"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    Edit Profile
                                  </Link>
                                </li>
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={open}
        size="lg"
        onHide={closeModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Upgrade Profile
          </Modal.Title>

        </Modal.Header>
        <Modal.Body>
          <h4>  Please upgrade a profile Photo as
            NFTs</h4>
          <p>
            We can upgrade our profile picture as a first NFTs for our trade and understanding about NFTs and marketplace.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => Navigate("/profile")}>Cancal</Button>
          <Button onClick={() => Upgrade()}>Upgrade Profile Photo as NFT</Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer position='bottom-right' />
      {/* {loader} */}
    </div>
  );
};

export default HeroProfile;
